import { useFormik, Form, FormikProvider } from 'formik';
import { Button, Input, Select } from 'styled';
import InputField from 'components/formik/InputField';
import Model from 'components/Modal';
import { getAllData, updateDocumentByID } from 'apis/customApiHandler';
import { useQuery, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { useCallback, useState } from 'react';
import ReactSelect from 'react-select';
import Add from './add';

const Edit = ({ handleClick, data, desable }) => {
  return (
    <Add handleClick={handleClick} data = {data} desable={desable}/>
  )
};

export default Edit;
